import React, { Component } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

class QuillEditor extends Component {
  constructor(props) {
    super(props);
    // initialize local state so this.state is not null
    this.state = {
      text: props.text || "",
    };
    this.quillRef = null;
  }
  componentDidUpdate(prevProps) {
    // if parent changes the text prop, sync to local state
    if (prevProps.text !== this.props.text) {
      this.setState({ text: this.props.text || "" });
    }
  }
  componentDidMount() {
    const quill = this.quillRef && this.quillRef.getEditor && this.quillRef.getEditor();

    // Listen for paste event
    quill.root.addEventListener("paste", (e) => {
      const clipboardData = e.clipboardData;
      if (clipboardData && clipboardData.items) {
        for (let i = 0; i < clipboardData.items.length; i++) {
          const item = clipboardData.items[i];
          if (item.type.indexOf("image") !== -1) {
            const file = item.getAsFile();
            const reader = new FileReader();
            reader.onload = (evt) => {
              const base64Image = evt.target.result;
              const range = quill.getSelection();
              quill.insertEmbed(range.index, "image", base64Image);
            };
            reader.readAsDataURL(file);
            e.preventDefault();
          }
        }
      }
    });
  }

  render() {
    const { handleChange, text, hideToolbar, toolbarBottom, id, placeholderValue, minHeight, maxHeight } = this.props;
    // hideToolbar prop controls whether the toolbar is shown
    const modules = hideToolbar
      ? { toolbar: false }
      : {
          toolbar: [
            ["bold", "italic", "underline"],
            [{ list: "ordered" }, { list: "bullet" }],
            ["link", "image"],
          ],
        };

    const formats = [
      "bold",
      "italic",
      "underline",
      "list",
      "bullet",
      "link",
      "image",
    ];
    const wrapperClass = `${hideToolbar ? "quill-no-toolbar" : ""}${
      toolbarBottom ? " quill-bottom-toolbar" : ""
    }`.trim();
    return (
      <div style={{ maxWidth: "700px", margin: "auto" }}>
        {/* <h3>Rich Text Editor with Paste Image Support</h3> */}
        {/* Optional CSS for toolbar bottom behaviour */}
        {toolbarBottom && (
          <style>{`
						.quill-bottom-toolbar { display: flex; flex-direction: column-reverse; }
						.quill-bottom-toolbar .ql-toolbar { order: 1;}
						.quill-bottom-toolbar .ql-container { order: 2; min-height: ${minHeight};max-height: ${maxHeight}; font-size:16px; overflow: auto; }
						/* ensure full width */
						.quill-bottom-toolbar .ql-toolbar, .quill-bottom-toolbar .ql-container { width: 100%; }
            .ql-toolbar.ql-snow + .ql-container.ql-snow { border-bottom: 0; border-top: 1px solid #ccc; }
					`}</style>
        )}
        {/* Optional CSS to ensure no gap when toolbar is hidden */}
        {hideToolbar && (
          <style>{`.quill-no-toolbar .ql-toolbar{display:none !important} .quill-no-toolbar .ql-container{min-height: ${minHeight}; max-height: ${maxHeight}; font-size: 16px; overflow: auto;}`}</style>
        )}

        <ReactQuill
          ref={(el) => (this.quillRef = el)}
          value={this.state.text}
          onChange={(value) => {
            // keep local output in sync
            this.setState({ text: value });
            // notify parent using existing onChange shape
            handleChange({ id, value });
          }}
          modules={modules}
          className={wrapperClass}
          placeholder={placeholderValue}
          formats={formats}
          theme="snow"
        />
      </div>
    );
  }
}

export default QuillEditor;
